import authentication from "@irati/auth"

const hasReacted = ({comment, item, reaction}) => {
  const results = item ? item.comments.results : [comment]

  const reactions = results.filter((r) =>
    r.createdBy.uuid === authentication.user().uuid
  )

  if (reactions.includes(reaction)) {
    return true
  }

  return false
}

export default hasReacted
